<div class="container d-flex flex-column mt-4">
    <h5 class="display-5 fw-bold">Bienvenido al Informe de Rendición</h5>
    
    <p class="lead mt-3 px-4">
      A continuación, debes completar el informe seleccionando los <strong>conceptos</strong> que te corresponden y justificando con los adjuntos necesarios en la pestaña <strong>Conceptos</strong>.
    </p>
    
    <p class="lead px-4">
      Luego, en la pestaña <strong>Informe</strong>, debes enviarlo para su revisión.
    </p>
  
<!--     <button class="btn btn-primary mt-4 px-4 py-2" (click)="goToNext()">Siguiente</button>
 -->  </div>